// @wc-ignore-file
/**
 * CR-185: an invite RPC refusal that keeps the Postgres error code, so the UI
 * can map it to translated copy (DB messages bypass wuchale) — e.g. P0185
 * when a domain invite is full, 22023 / 42501 from update_domain_invite.
 */
export class InviteRpcError extends Error {
  readonly code: string | null;
  readonly dbMessage: string;

  constructor(prefix: string, error: { message: string; code?: string | null }) {
    super(`${prefix}: ${error.message}`);
    this.name = "InviteRpcError";
    this.code = error.code ?? null;
    this.dbMessage = error.message;
  }
}

/**
 * CR-185: the sign-up form's invite link is a domain invite that reached its
 * maximum. The auth hook only answers "No invite was found" (GoTrue hides
 * P0185), so signInWithEmail raises this after its get_invite_by_code read
 * said the link is full.
 */
export class InviteFullError extends Error {
  constructor() {
    super("This invite link has reached its maximum number of members");
    this.name = "InviteFullError";
  }
}
